import { Box } from "@material-ui/core";
import React from "react";
import { AccountContact } from "../../../api/services";
import { ContactField, ContactInfo } from "./ContactField";

export const buildContactInfo = (contact: AccountContact): ContactInfo => ({
  dateOfBirthDt: contact.dateOfBirthDt,
  phoneNumber: contact.number1 || contact.number2 || contact.number3,
  email: contact.email,
});

export const ContactFields: React.FC<Omit<ContactInfo, "email">> = ({
  dateOfBirthDt,
  phoneNumber,
}) => (
  <>
    <Box mb={2}>
      <ContactField label="Date of Birth" value={dateOfBirthDt} />
    </Box>
    <Box mb={2}>
      <ContactField label="Phone Number" value={phoneNumber} />
    </Box>
  </>
);
